import { useMemo } from "react";
import { AuditTask } from "../../types";
import { PanelCard } from "../ui/panel";
import {
  buildUserTaskPerformance,
  hasClosedTasks,
} from "./auditTaskPerformanceUtils";
import TaskPerformanceCard from "./TaskPerformanceCard";

interface UserTaskPerformanceProps {
  tasks: AuditTask[];
}

export default function UserTaskPerformance({ tasks }: UserTaskPerformanceProps) {
  const row = useMemo(() => buildUserTaskPerformance(tasks), [tasks]);
  const anyClosed = hasClosedTasks(tasks);

  if (!row) return null;

  return (
    <PanelCard title="Le tue performance" subtitle="Riepilogo delle task assegnate">
      {!anyClosed && (
        <p className="mb-4 rounded-xl border border-dashed border-secondary/15 bg-secondary/[0.02] px-4 py-3 text-center text-sm text-secondary/50">
          Nessuna task chiusa ancora — le metriche includono solo le task attive.
        </p>
      )}
      <TaskPerformanceCard row={row} showHeader={false} />
    </PanelCard>
  );
}
